export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '구분' }, { name: '조사일' }, { name: '조사자' }, { name: '소속명' }, { name: '부서명' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).regularly // 구분
      case 2: return func.getContent(value).stdInfo.조사일 // 조사일
      case 3: return func.getContent(value).stdInfo.조사자 // 소속명
      case 4: return func.getContent(value).stdInfo.department // 소속명
      case 5: return func.getContent(value).stdInfo.section ? func.getContent(value).stdInfo.section : func.getContent(value).stdInfo.com_name // 부서명
      case 6: return func.getContent(value).stdInfo.writer_name // 작성자
      case 7: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  // getSearchKeyValue: (nav) => {
  //   if (nav.value.created_at) {
  //     nav.dateTarget = 'created_at'
  //     nav.dateBegin = 'nav.value.created_at.sDate'
  //     nav.dateEnd = 'nav.value.created_at.eDate'
  //   }
  //   return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  // },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '조사일': returnData.push('content$body.stdInfo."조사일"*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': 'content$body.stdInfo.section*%[:default_skw]%' ? returnData.push('content$body.stdInfo.section*%[:default_skw]%') : returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }
    return returnData
  },

  getSearchKeyValue: (nav) => {
    nav.conditions = []

    if (nav.value.created_at.sDate) {
      nav.conditions.push({
        operator: ">=",
        value: nav.value.created_at.sDate,
        key: 'created_at',
      })
    }
    if (nav.value.created_at.eDate) {
      nav.conditions.push({
        operator: "<=",
        value: nav.value.created_at.eDate,
        key: 'created_at',
      })
    }

    if (nav.value.regularly && nav.value.regularly.length > 0) {
      nav.conditions.push({
        operator: "LIKE",
        value: `${nav.value.regularly.toString()}%`,
        key: 'body.regularly',
      })
    }

    if (nav.value.searchType && nav.value.searchKeyword) {
      let key = ''
      switch (nav.value.searchType) {
      case '사업장명': key = 'body.stdInfo.field_name'; break
      case '조사일': key = 'body.stdInfo.조사일'; break
      case '소속명': key = 'body.stdInfo.department'; break
      case '부서명': key = 'body.stdInfo.section'; break
      case '작성자': key = 'body.stdInfo.writer_name'; break
      }
      nav.conditions.push({
        operator: "LIKE",
        value: `%${nav.value.searchKeyword}%`,
        key,
      })
    }

    return { conditions: nav.conditions }
  },
}
